import gql from "graphql-tag";

const query = gql`
  query Sources(
    $offset: Int
    $limit: Int
    $customerId: ID
    $deploymentId: ID
    $status: String
    $usuallyDisconnected: Boolean
  ) {
    sources(
      offset: $offset
      limit: $limit
      customerId: $customerId
      deploymentId: $deploymentId
      status: $status
      usuallyDisconnected: $usuallyDisconnected
    ) {
      items {
        id
        lastStatus
        lastChecked
        description
        brand
        model
        serial
        type
        use
        owner
      }
      total
    }
  }
`;

export default query;

export const getSourcesQuery = variables => ({
  query,
  variables,
});
